<div class="bg-surface flex h-full min-h-0 flex-col gap-3 overflow-auto p-3">
  <div class="flex flex-wrap items-center justify-between gap-2">
    <div class="flex flex-wrap items-center gap-1">
      @for (siteUid of siteUids(); track siteUid) {
        <button
          type="button"
          data-testid="occupation-site"
          class="border-default text-text-secondary hover:bg-interactive cursor-pointer rounded-sm border px-2 py-0.5 text-[11px] transition-colors"
          [class.bg-accent-interactive]="selectedSites().has(siteUid)"
          [class.text-text-primary]="selectedSites().has(siteUid)"
          [attr.aria-pressed]="selectedSites().has(siteUid)"
          (click)="toggleSite(siteUid)">
          {{ siteUid }}
        </button>
      }
    </div>

    <div class="flex items-center gap-1">
      @for (option of forms; track option) {
        <button
          type="button"
          class="border-default text-text-secondary hover:bg-interactive cursor-pointer rounded-sm border px-2 py-0.5 text-[11px] font-semibold transition-colors"
          [class.bg-accent-interactive]="form() === option"
          [class.text-text-primary]="form() === option"
          [attr.aria-pressed]="form() === option"
          (click)="setForm(option)">
          {{ 'visualization.occupation.form.' + option | translate }}
        </button>
      }
      <button
        type="button"
        class="border-default text-text-secondary hover:bg-interactive cursor-pointer rounded-sm border px-2 py-0.5 text-[11px] transition-colors"
        [class.text-text-primary]="showTable()"
        [attr.aria-pressed]="showTable()"
        [attr.aria-label]="'visualization.occupation.table.toggle' | translate"
        (click)="toggleTable()">
        <i [class]="ICONS.list"></i>
      </button>
    </div>
  </div>

  @if (loading()) {
    <p class="text-text-tertiary py-6 text-center text-xs">
      {{ 'visualization.occupation.loading' | translate }}
    </p>
  } @else if (visibleSeries().length === 0) {
    <p class="text-text-tertiary py-6 text-center text-xs">
      {{ 'visualization.occupation.empty' | translate }}
    </p>
  } @else {
    <app-occupation-legend surface="module" [form]="form()" />

    <app-occupation-chart [series]="visibleSeries()" [form]="form()" />

    @if (showTable()) {
      <app-occupation-table [series]="visibleSeries()" />
    }
  }
</div>
